import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { StateService } from '../shared/state.service';
import { ApiService } from '../shared/api.service';
import { environment } from '../../environments/environment';
import { UtilsService } from '../shared/utils.service';

@Injectable({
  providedIn: 'root',
})
export class ResolveGuard {
  constructor(private readonly router: Router, private readonly stateService: StateService) {}

  resolve() {
    try {
      const hash = UtilsService.decodeBase64(UtilsService.getHashSubstring(1));
      if (hash.hasOwnProperty('error')) {
        if (['AUTO_CREDENTIALS', 'CUSTOM_CREDENTIALS_EXPIRED'].indexOf(hash.error) >= 0) {
          this.goToForceChangePassword();
        }
        if (['AUTO_CREDENTIALS_EXPIRED'].indexOf(hash.error) >= 0) {
          this.goToForceResetPassword();
        }
        if (hash.error === 'SESSION_TIMEOUT') {
          return false;
        }
      }
      return true;
    } catch (e) {}
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve: any) => {
      if (this.stateService.getClientId() === undefined) {
        this.router.navigate(['errorPage']);
        resolve(false);
      } else {
        if (
          this.stateService.getClientId() !== 'docheavenCOL' &&
          (state.url.includes('/reset-password') ||
            state.url.includes('/force-change-password') ||
            state.url.includes('/force-reset-password'))
        ) {
          this.router.navigate(['errorPage']);
          resolve(false);
        }
      }
      resolve(true);
    });
  }

  goToForceChangePassword() {
    this.router.navigate(['force-change-password'], { fragment: UtilsService.getHashSubstring(1) });
    return false;
  }

  goToForceResetPassword() {
    this.router.navigate(['force-reset-password']);
    return false;
  }
}
